import Vue from 'vue'
import Vuex from 'vuex'

import mutations from './mutations'
import getters from './getters'
import actions from './actions'
import { IEntity } from '../interfaces/entity.interface'

Vue.use(Vuex)

export interface State {
	entity: IEntity | null
	backupEntity: IEntity | null
	questions: any[]
	privacyStatementSelected: boolean
}

const state: State = {
	entity: null,
	backupEntity: null,
	questions: [],
	privacyStatementSelected: false
}

export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions
})
